var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1179"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1179"
    },
    "bundlingPackage": "data-privacy-request-ui",
    "bundlingPackageVersion": "static-1.5626",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};